/**
 * Utility Functions
 * Math helpers and common utilities
 */

export function lerp(a, b, t) {
    return a + (b - a) * t;
}

export function clamp(value, min, max) {
    return Math.max(min, Math.min(max, value));
}

export function randomRange(min, max) {
    return Math.random() * (max - min) + min;
}

export function randomInt(min, max) {
    return Math.floor(Math.random() * (max - min + 1)) + min;
}

// Perlin-like noise function (simplex approximation)
export function noise(x, y = 0, seed = 0) {
    const n = Math.sin(x * 12.9898 + y * 78.233 + seed) * 43758.5453;
    return n - Math.floor(n);
}

// Smooth noise with interpolation
export function smoothNoise(x, frequency = 1, seed = 0) {
    const scaledX = x * frequency;
    const x0 = Math.floor(scaledX);
    const x1 = x0 + 1;
    const t = scaledX - x0;

    // Smoothstep interpolation
    const smoothT = t * t * (3 - 2 * t);

    const n0 = noise(x0, 0, seed);
    const n1 = noise(x1, 0, seed);

    return lerp(n0, n1, smoothT);
}

// Fractal noise (multiple octaves)
export function fractalNoise(x, octaves = 4, persistence = 0.5, seed = 0) {
    let total = 0;
    let frequency = 1;
    let amplitude = 1;
    let maxValue = 0;

    for (let i = 0; i < octaves; i++) {
        total += smoothNoise(x, frequency, seed + i * 100) * amplitude;
        maxValue += amplitude;
        amplitude *= persistence;
        frequency *= 2;
    }

    return total / maxValue;
}

// Distance between two points
export function distance(x1, y1, x2, y2) {
    const dx = x2 - x1;
    const dy = y2 - y1;
    return Math.sqrt(dx * dx + dy * dy);
}

// Ease functions
export const Ease = {
    linear: t => t,
    quadIn: t => t * t,
    quadOut: t => t * (2 - t),
    quadInOut: t => t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t,
    cubicIn: t => t * t * t,
    cubicOut: t => (--t) * t * t + 1,
    sineIn: t => 1 - Math.cos(t * Math.PI / 2),
    sineOut: t => Math.sin(t * Math.PI / 2),
    elastic: t => {
        if (t === 0 || t === 1) return t;
        return Math.pow(2, -10 * t) * Math.sin((t - 0.1) * 5 * Math.PI) + 1;
    }
};
